module.exports = __webpack_public_path__ + "static/media/notification.897734e4.mp3";